import { MilestoneFilterStatusFlag } from '@bechtel/types';

export const milestoneFlagList = [
  { id: 1, value: MilestoneFilterStatusFlag.BLOCKED, label: 'Blocked', scope: [true, false] },
  { id: 2, value: MilestoneFilterStatusFlag.REJECTED, label: 'Rejected', scope: [true, false] },
  //TODO: BE not implementing this search as per PO's request
  // { id: 3, value: MilestoneFilterStatusFlag.ALL_UNPLANNED, label: 'All Unplanned', scope: [true, false] },
  { id: 4, value: MilestoneFilterStatusFlag.EXPIRED, label: 'Expired', scope: [true, false] },
];
